import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Anesthesiology = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.671 8.324 35.695.33c-.997-1-2.393.5-1.496 1.499l3.19 3.197-3.888 3.898-4.487-4.597c-.398-.4-1.096-.4-1.495 0L15.654 16.219l-7.08 7.095c-.398.4-.398 1.1 0 1.499l.998 1.1-3.49 3.497c-.2.2-.3.5-.3.7 0 .3.1.5.3.699l2.792 2.798-8.575 8.594c-.399.4-.399 1.1 0 1.5.399.399 1.097.399 1.496 0l8.574-8.595 2.792 2.798c.2.2.499.3.698.3.3 0 .499-.1.698-.3l3.49-3.498.997 1c.399.4 1.097.4 1.495 0l7.08-7.095 11.864-11.892c.4-.4.4-1.1 0-1.5l-4.586-4.596 4.088-3.798 3.19 3.198c.998 1 2.493-.5 1.496-1.399ZM28.317 6.525l3.888 3.898-10.47 10.393-3.888-3.898 10.47-10.393Zm-14.358 29.18L8.276 30.01l2.791-2.699 5.584 5.596-2.692 2.799Zm5.982-2.398-9.173-9.294 5.683-5.596 9.173 9.194-5.683 5.696ZM37.49 15.72 27.12 26.112l-3.889-3.897 10.37-10.393 3.888 3.897Z"
  }));
});
Anesthesiology.displayName = 'Anesthesiology';
Anesthesiology.defaultProps = {
  'aria-label': 'Anesthesiology'
};
export default Anesthesiology;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Anesthesiology.js
// module id = 3601
// module chunks = 11